import styled from 'styled-components/macro';
export const ContainerStyled = styled.div `
  ${({ styles }) => styles}
`;
